import { getTextLabelForDateRange } from 'owa-files-filter-date-filter';
import { DateRangeFilter } from 'owa-files-filter-date-filter';
import { FileExtensionType, getFileExtensionData } from 'owa-files-filter-file-extensions-filter';
import { Pill } from 'owa-files-filter-pill';
import { clearDateFilterAction, clearExtensionFilterAction } from 'owa-files-filter-contextmenu';
import DateRange from 'owa-range-datepicker/lib/store/schema/DateRange';

export function getFilterPills(
    dateFilterRange: DateRangeFilter,
    extensionGroupFilter: FileExtensionType[]
): Pill[] {
    const pills = [];
    if (extensionGroupFilter && extensionGroupFilter.length > 0) {
        pills.push(
            ...extensionGroupFilter.map(a => getPillForExtension(Number(a) as FileExtensionType))
        );
    }
    if (
        dateFilterRange &&
        dateFilterRange.dateRange &&
        dateFilterRange.dateRange.endDate &&
        dateFilterRange.dateRange.startDate
    ) {
        pills.push(getPillForDate(dateFilterRange.dateRange));
    }
    return pills;
}

function getPillForDate(dateRange: DateRange) {
    return {
        text: getTextLabelForDateRange(dateRange),
        onRemove: () => clearDateFilterAction(),
    };
}

function getPillForExtension(ext: FileExtensionType) {
    return {
        text: getFileExtensionData(ext).text,
        onRemove: () => clearExtensionFilterAction(ext),
    };
}
